export const iconFontAwesomeMarketingAnchorCircleCheck = (
	<i className="fa-solid fa-anchor-circle-check"></i>
);
